import {
  FareRequest,
  FareSelectorList,
  TravelArea,
  TravelMethod,
  TravelTime,
} from '@modules/ticket-fares-store/client/src';
import { isNullOrUndefined } from '@nx-ng/util';
import { IFareSelectorsBoolean } from '../../../types';

export const highlightInvalidSelections = ({
  fareSelectorList,
  invalidSelections,
  currentSelections,
}: {
  fareSelectorList: FareSelectorList | undefined;
  invalidSelections: IFareSelectorsBoolean;
  currentSelections: Partial<FareRequest>;
}): IFareSelectorsBoolean => {
  const newInvalidSelections = {
    ...invalidSelections,
  };
  const allZones =
    fareSelectorList?.zones?.map((zone: TravelArea) => zone.id!) || [];

  const allTravelMethods =
    fareSelectorList?.travelMethods?.map(
      (method: TravelMethod) => method.id!
    ) || [];

  const allTravelTimes =
    fareSelectorList?.travelTimes?.map((method: TravelTime) => method.id!) ||
    [];

  if (
    !isNullOrUndefined(currentSelections?.zone) &&
    !allZones.includes(currentSelections?.zone!)
  ) {
    newInvalidSelections.zone = true;
  }

  if (
    !isNullOrUndefined(currentSelections?.travelMethod) &&
    !allTravelMethods.includes(currentSelections?.travelMethod!)
  ) {
    newInvalidSelections.travelMethod = true;
  }

  if (
    !isNullOrUndefined(currentSelections?.travelTime) &&
    !allTravelTimes.includes(currentSelections?.travelTime!)
  ) {
    newInvalidSelections.travelTime = true;
  }

  return newInvalidSelections;
};
